export class DataStore {

  // In-memory fallback storage for when sessionStorage is unavailable
  static memoryStorage = {};

  // Check if sessionStorage is available and working
  static isSessionStorageAvailable() {
    try {
      const testKey = '__sessionStorageTest__';
      sessionStorage.setItem(testKey, 'test');
      sessionStorage.removeItem(testKey);
      return true;
    } catch (e) {
      return false;
    }
  }

  static set(key, value) {

    if (!key) {
      return;
    }

    const serializedValue = JSON.stringify(value);

    try {
      sessionStorage.setItem(key, serializedValue);
      return;
    } catch (e) {
      console.error('DataStore', 'set', e);
    }

    this.memoryStorage[key] = serializedValue;
  }

  static get(key) {

    if (!key) {
      return;
    }

    try {
      let val = sessionStorage.getItem(key);
      if (val !== null && val !== undefined) {
        return JSON.parse(val);
      }
    } catch (e) {
      console.error('DataStore', 'get', e);
    }

    // Fallback to in-memory storage
    const val = this.memoryStorage[key];
    if (!val) {
      return val;
    }

    return JSON.parse(val);
  }

  static clear(key) {

    if (!key) {
      return;
    }

    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      console.error('DataStore', 'clear', e);
    }

    delete this.memoryStorage[key];
  }

  static clearAll() {
    try {
      sessionStorage.clear();
    } catch (e) {
      console.error('DataStore', 'clearAll', e);
    }

    this.memoryStorage = {};
  }
}